// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import { RightOutlined } from "@ant-design/icons";
import styled from "styled-components";

const Container = styled.span`
  padding: 0 3px;
  cursor: pointer;
  margin-left: 2px;
  display: inline-block;
  &:hover {
    background: #eee;
  }
  &:active {
    background: #ddd;
  }
  .down {
    display: block;
    transform: rotate(90deg);
  }
`;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'extend' implicitly has an 'any' type.
function Toggler({ extend, onClick }) {
  return (
    <Container onClick={onClick}>
      <span className={extend ? "down" : ""}>
        <RightOutlined />
      </span>
    </Container>
  );
}

export { Toggler };
